import { smartDateString } from '../../../../../utils/date';
import {
  convertDigitToProperFormat,
  isANumber,
} from '../../../../../utils/number';
import { IUser } from 'store/users/usersType';
import i18n from '../../../../../i18n';

export default {
  back: 'بازگشت',
  showPrevResponses: 'نمایش پاسخ‌های قبلی',
  deletedQuestion: 'پرسش حذف شده',
  edit: 'ویرایش',
  previousResponses: 'پاسخ‌های قبلی',
  responseUpdated: 'پاسخ به روز شد',
  responseSend: 'پاسخ با موفقیت ارسال شد',
  responseSendAsDraft: 'پاسخ به صورت پیشنویس ذخیره شد',
  downloadResponses: 'دریافت خروجی Excel',
  includeScore: 'نمایش امتیاز',
  download: 'دریافت',
  doneSubmitResponseMessage: 'پاسخ شما با موفقیت ارسال شد',
  submitDate_desc: 'جدید ترین ارسال',
  updateDate_desc: 'جدید ترین به روز رسانی',
  effectiveDate_desc: 'جدیدترین بازه مرتبط',
  emptyPlaceHolder: 'برای مشاهده جزئیات لطفا پاسخی را انتخاب کنید',
  searchById: 'جستجو با شناسه',
  importResponsesFromExcel: 'بارگیری پاسخ‌ها از Excel',
  invalidFile: 'فایل انتخاب شده متعبر نیست',
  selectFile: 'انتخاب فایل Excel',
  notImportedRows:
    'سطرهای زیر به دلیل عدم تطابق بین گزینه‌ها و یا عدم موجود بودن سوال اجباری وارد نشدند\n',
  import: 'ارسال',
  importNote: 'نکات مرتبط با بارگیری',
  importNoteMatchColumnName:
    'در فایل ارسالی باید سطر اول عناوین ستون ها باشد و باید منطبق بر نام سوالات باشند',
  importNoteIndicator:
    'در صورت وجود مخرج در سوال شاخصی باید ستون اول مقدار صورت و ستون بعدی مقدار مخرج باشد و ستون مخرج بدون عنوان باشد',
  importNoteMultiChoice:
    'در سوالات چند گزینه ای چند پاسخه پاسخ ها باید در یک سلول بوده و با یکی از کاراکتر های « - , ، / » جدا شده باشند',
  importNoteProblem:
    'در صورت هرگونه اشکال در هر سطر آن سطر وارد نمی‌شود و اطلاع داده می‌شود',
  importNoteNoProblem:
    'همچنین از ستون‌های اضافی یا مقادیر اشتباه تا زمانی که مشکلی در ارسال پاسخ ایجاد نکند(مثلا سوال اختیاری باشد) بدون هیچ هشداری صرف نظر می‌شود',
  importNoteExportNotCompatible:
    'لازم به ذکر است که فایل خروجی Excel که سامانه ایجاد می‌کند به صورت مستقیم قابل بارگیری نیست',
  shouldOpenNextMessage: 'پاسخ شما با موفقت ارسال شد، ایا سند بعدی باز شود؟',
  deletedValue: 'مقدار حذف شده',
  search: 'جستجو',
  randomResponse: 'پاسخ سریع تصادفی',
  createAnalyseForm: 'ساخت فرم تحلیل',
  analyse: 'تحلیل',
  analysePeriod: 'بازه زمانی تحلیل',
  manageAnalyseAccess: 'مدیریت دسترسی به تحلیل',
  addNewAnalyse: 'ثبت تحلیل جدید',
  showAnalyseSurvey: 'ویرایش سند تحلیل',
  linkAnalyse: 'لینک به تحلیل',
  save: 'ذخیره لینک',
  invalidAnalyseItem: 'سند تحلیل مورد نظر معتبر نیست',
  currectAnswer: 'پاسخ صحیح',
  exportExcel: 'خروجی اکسل',
  importExcel: 'دریافت از طریق اکسل',
  score: 'امتیاز',
  title: 'توضیح پاسخ',
  login: 'ورود',
  delete: 'حذف',
  responses: 'پاسخ‌های',
  description: 'توضیحات',
  unknownUser: 'کاربر ناشناس',
  withoutName: '<بدون نام>',
  withoutScore: 'ندارد',
  addNewResponse: 'افزودن پاسخ',
  removeResponse: 'آیا مطمئن هستید که می‌خواهید این پاسخ را پاک کنید؟',
  searchProvider: 'جستجوی کاربر',
  thereIsNoAnswerYet: 'هنوز پاسخی ارسال نشده است.',
  loginToViewResponse: 'برای مشاهده‌ی پاسخ‌ها لطفا وارد سامانه شوید',
  filteredResponsesBasedOn: 'پاسخ‌های محدود شده به',
  clear: 'حذف',
  scoreAverage: 'میانگین امتیاز',
  and: 'و',
  minutes: 'دقیقه',
  hour: 'ساعت',
  effectiveDate: 'تاریخ موثر',
  submitDate: 'تاریخ ارسال',
  preventRefill: 'امکان تکمیل دوباره وجود ندارد',

  loadedResponses(count: string) {
    return i18n.t('loadedResponses', {
      ns: 'survey',
      count: !isANumber(count) ? 0 : Number(count),
    }) as string;
  },
  responseScore(score: number | string, maxScore?: number) {
    const scoreText = convertDigitToProperFormat(score);
    let ret = i18n.t('result', { ns: 'survey', result: scoreText });
    if (maxScore) {
      ret +=
        ' ' +
        i18n.t('fromScore', {
          ns: 'survey',
          score: convertDigitToProperFormat(maxScore),
        });
    }
    return ret;
  },
  gridResponseScore(score: number | string, text: string, maxScore?: number) {
    const scoreText = convertDigitToProperFormat(score);
    const fromPart = maxScore
      ? ` از ${convertDigitToProperFormat(maxScore)}`
      : '';
    if (text === scoreText) {
      return fromPart;
    }
    return ` (امتیاز: ${scoreText} ${fromPart} )`;
  },
  indicatorResult(result: string, unit: string) {
    return i18n.t('indicatorResult', { ns: 'survey', unit, result });
  },
  getResponseTitle(title?: string) {
    const responseTitle = title ? `«${title}» - ` : '';
    return responseTitle;
  },
  answeredBy(user?: IUser, isPersian: boolean = true) {
    let userName = null;
    if (!user) {
      userName = this.unknownUser;
    } else {
      userName =
        user.name ||
        (isPersian
          ? `کاربر بدون نام (${user.id})`
          : `User ${user.id} has no name.`);
    }
    return isPersian ? `توسط: ${userName}` : `By: ${userName}`;
  },
  lockStatus(status: boolean) {
    const activeLanguage = i18n.language;
    switch (activeLanguage) {
      case 'fa':
        return status ? 'قفل' : 'باز';
        break;
      case 'en':
        return status ? 'Lock' : 'Open';
        break;
      default:
        return status ? 'قفل' : 'باز';
    }
  },
  draftStatus(status: boolean) {
    const activeLanguage = i18n.language;
    switch (activeLanguage) {
      case 'fa':
        return status ? 'پیش‌نویس' : 'مصوب';
        break;
      case 'en':
        return status ? 'Draft' : 'Ratified';
        break;
      default:
        return status ? 'پیش‌نویس' : 'مصوب';
    }
  },
  fileName(name: string) {
    return i18n.t('fileName', { ns: 'survey', name });
  },
  fileSize(size: string) {
    return i18n.t('fileSize', { ns: 'survey', size });
  },
  fileType(type: string) {
    return i18n.t('fileType', { ns: 'survey', type });
  },
  versionTitle(date: Date, userName: string, stage?: string) {
    return (
      (stage ? stage + ' - ' : '') +
      smartDateString(date, true) +
      ' - ' +
      (userName || '')
    );
  },
  addTask(name: string) {
    return i18n.t('addTask', { ns: 'survey', name: name });
  },
  numberOfRowsImported(size: number) {
    return i18n.t('numberOfRowsImported', { ns: 'survey', size: size });
  },
};
